<template>
  <view>
    <dl class="tab">
      <dt
        v-for="(item,index) in list"
        :key="index"
        :class="index===hover?'s':''"
        :style="{marginRight:`${spacing}px`}"
        @click="tabClick(index)"
      >
        {{ item.title }}
        <div
          class="point"
        />
      </dt>
      <dd
        class="line"
        :style="lineStyle"
      >
        <view
          class="_line"
          :style="{
            width:`${lineWidth}%`,
            background:lineColor
          }"
        />
      </dd>
    </dl>
  </view>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
            default(){
                return[];
            }
        },
        lineWidth:{
            type:Number,
            default:80
        },
        spacing:{
            type:Number,
            default:20
        },
        lineColor:{
            type:String,
            default:'#E3B979'
        }
    },
    data(){
        return{
            hover:0,
            viewInfo:[],
            lineStyle:{

            }
        };
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            let view=uni.createSelectorQuery().in(this).selectAll('dt');
            view.boundingClientRect(res=>{
                this.viewInfo=res;
                this.lineStyle={
                width:res[0].width+'px'
            };
            }).exec();
        },
        tabClick(index){
            this.hover=index;
            let left=0;
            for(let i=0;i<index;i++){
                left+=this.viewInfo[i].width;
            }
            this.lineStyle={
                width:this.viewInfo[index].width+'px',
                transform:`translateX(${left+this.spacing*index}px)`
            };
            this.$emit('change',index);
        }
    }
};
</script>

<style lang="less" scoped>
.tab{
    display: flex;
    height:60upx;
    align-items: center;
    position: relative;
    .line{
        height:10upx;
        position: absolute;
        bottom:-10upx;
        left:0;
        transition: all .4s ease;
        display: flex;
        justify-content: center;
        ._line{
            height:100%;
            border-radius:18upx;
        }
    }
    dt{
        position: relative;
        color:#666;
        .point{
            position: absolute;
            width:16upx;
            height:16upx;
            border-radius: 16upx;
            background:rgba(241,99,70,1);
            right:-14upx;
            top:-10upx;
        }
        &.s{
            color:#262626;
        }
    }
}
</style>